"use client";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTypedTranslations } from "@/i18n/typed";
import { useRouter } from "next/navigation";

export default function CampaignDialogAddCompleted({
  open,
  onClose,
  checkAddMedia = true,
}: {
  open: boolean;
  onClose: () => void;
  checkAddMedia: boolean;
}) {
  const router = useRouter();
  const t = useTypedTranslations("dialogs");

  return (
    <Dialog open={open} onOpenChange={() => onClose()}>
      <DialogContent showCloseButton={false} className="max-w-md gap-5">
        <DialogHeader className="gap-2">
          {checkAddMedia ? (
            <DialogTitle className="text-[#24292E] leading-[130%] tracking-[-0.08px]">
              {t("campaignDialogAddCompleted.titleSuccess")}
            </DialogTitle>
          ) : (
            <DialogTitle className="text-[#24292E] leading-[130%] tracking-[-0.08px]">
              {t("campaignDialogAddCompleted.titleAlreadyExists")}
            </DialogTitle>
          )}
          <DialogDescription className="font-semibold leading-[130%] tracking-[-0.08px]">
            {t("campaignDialogAddCompleted.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-3.5">
          <Button
            type="button"
            variant="secondary"
            tone="light"
            onClick={() => {
              onClose();
            }}
            className="px-5 py-4 text-gray-700 "
          >
            {t("campaignDialogAddCompleted.cancelText")}
          </Button>
          <Button
            onClick={() => {
              router.push("/dashboard/my-campaign");
            }}
            type="button"
            className="px-5 py-4"
          >
            {t("campaignDialogAddCompleted.goText")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
